import { NgModule } from '@angular/core';
import { EditMealPage } from 'pages/edit-meal/edit-meal';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [EditMealPage],
    imports: [PagesModule, ComponentsModule]
})
export class EditMealPageModule {}
